import { render, staticRenderFns } from "./DataAnggota.vue?vue&type=template&id=2870d35e&"
import script from "./DataAnggota.vue?vue&type=script&lang=js&"
export * from "./DataAnggota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports